export const financialsRoutes = {
  'route.order.factor': '/financials/order/[id]',
  'route.order.expired': '/financials/order/expired',
  'route.order.card-to-card': '/financials/order/card-to-card/[id]',
  'api.order.item': 'financials/order/[orderItemId]',
  'api.send.order': 'financials/payment/pay',
  'api.order.list': 'financials/order/datatable',
  'api.credit.list': 'financials/credit/datatable',
  'api.order.pdf': 'financials/order/pdf-download/[id]',
  'api.order.wallet-credit': 'financials/credit/find',
  'api.order.total-count': 'financials/order/total',
  'api.order.charge-wallet': 'financials/credit',
  'api.order.store-card-to-card-receipt': 'financials/order/upload-receipt',
  'api.order.upload-file': 'upload/[sectionType]/[year]/[month]/[day]/[time]/[type]/file',
  'api.order.reject-reason-list': 'financials/order/reason-list',
  'api.order.cancel-order': 'financials/order/cancel-order',
  'api.order.pre-invoice': 'financials/pre-invoice/datatable',
  'api.order.survey': 'financials/order/survey/[orderId]',
  'api.send.reorder': 'financials/order/reorder',
};
